'use client'

import React from 'react'

import { MediaZoomWrapper } from './MediaZoomWrapper'

/** Classe base da `<figure>` — compartilhada também pelo bloco de vídeo. */
export const MEDIA_FIGURE_SHELL_CLASS = 'relative w-full'

type Props = {
  alt: string
  /** Legenda visível (sempre presente — complementa o ALT). */
  figcaption: React.ReactNode
  figcaptionClassName?: string
  height?: number
  imgClassName?: string
  priority?: boolean
  src: string
  width?: number
  /** Atributos `data-image-object-*` para structured data / SEO. */
  seoFigureAttributes?: Record<string, string>
  /** `sizes` do Next/Image na miniatura (inline no artigo). */
  sizes?: string
}

/**
 * Invólucro semântico `<figure>` para imagens do MediaBlock.
 * A imagem é sempre centralizada e abre um overlay de zoom ao clicar.
 */
export function MediaFigure({
  alt,
  figcaption,
  figcaptionClassName,
  height,
  imgClassName,
  priority = false,
  src,
  width,
  seoFigureAttributes,
  sizes,
}: Props) {
  return (
    <figure className="relative mx-auto min-w-0 w-fit max-w-full" {...seoFigureAttributes}>
      <MediaZoomWrapper
        alt={alt}
        height={height}
        imgClassName={imgClassName}
        priority={priority}
        sizes={sizes}
        src={src}
        width={width}
      />

      {figcaption ? <figcaption className={figcaptionClassName}>{figcaption}</figcaption> : null}
    </figure>
  )
}
